import { utc } from 'moment';
import Vue from 'vue';

Vue.filter('asTimer', (duration) => utc(duration.as('ms')).format('HH:mm:ss'));
